import { useState } from 'react';

export default function Base() {
    const getToken = () => {
        const userToken = localStorage.getItem('token');
        return userToken
    };

    const [token, setToken] = useState(getToken());

    const removeToken = () => {
        localStorage.removeItem('token');
        setToken(null);
    };

    const saveToken = userToken => {
        localStorage.setItem('token', userToken);
        setToken(userToken);
    };

    const getURL = () => {
        return 'https://logger.nezvanov.ru/';
    };

    return {
        setToken: saveToken,
        getToken,
        removeToken,
        token,
        getURL
    }
}